import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import './homelang.scss';
import Footerlang from '../../components/footerlang/footerlang';
import Navlang from '../../components/navbarlang/navlang';
import Clock from '../../components/clock/clock';
import BannerCarousel from '../../components/courosel/courosel';
const config = require('../../config');
class Homelang extends Component {
  constructor() {
    super();
    this.state = {
      currDate: new Date().toDateString(),
      currTime: this.formatAMPM(new Date()),
      dropDownEx: false,
      showDottedAnim: false,
      TemplesAroundKumbakonam: false,
      otherPilgrimages: false,
      nearestTourism: false,
      unescoTemples: false,
      currMnthEvent: []
    };
    this.myRef = React.createRef()
  }
  componentDidMount() {
    setInterval(() => this.tick(), 1000);
    fetch(config['baseurl'] + 'fetchgallery.php', {
      method: 'GET'
    })
      .then(response => response.json())
      .then(data => {
        let currMnthEve = [];
        if (data.length > 5) {
          currMnthEve = data.slice(Math.max(data.length - 5, 1));
        } else {
          currMnthEve = data;
        }
        this.setState({
          currMnthEvent: currMnthEve
        });
      });
  }

  componentWillUnmount() {
    clearInterval(this.currTime);
  }
  onScroll = () => {
    let scrollTop = this.myRef.current.scrollTop
    if (scrollTop > 100) {
      this.setState({
        showDottedAnim: true
      })
    } else {
      this.setState({
        showDottedAnim: false
      })
    }
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }
  tick() {
    this.setState({
      currTime: this.formatAMPM(new Date())
    });
  }
  showAbout() {
    document.getElementById('aboutCnt').scrollIntoView({ behavior: "smooth", block: "nearest" })
  }
  toggleClass(param) {
    if (param == 'TemplesAroundKumbakonam') {
      const currentState = this.state.TemplesAroundKumbakonam;
      this.setState({
        TemplesAroundKumbakonam: !currentState
      },
        () => {
          if (!currentState) {
            document.getElementById('TemplesAroundKumbakonam').scrollIntoView({ behavior: "smooth", block: "start" })
          }
        }
      );
    } else if (param == 'otherPilgrimages') {
      const currentState1 = this.state.otherPilgrimages;
      this.setState({
        otherPilgrimages: !currentState1
      },
        () => {
          if (!currentState1) {
            document.getElementById('otherPilgrimages').scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
          }
        }
      );
    } else if (param == 'nearestTourism') {
      const currentState2 = this.state.nearestTourism;
      this.setState({
        nearestTourism: !currentState2
      }, () => {
        if (!currentState2) {
          document.getElementById('nearestTourism').scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }
      });
    } else if (param == 'unescoTemples') {
      const currentState3 = this.state.unescoTemples;
      this.setState({
        unescoTemples: !currentState3
      },
        () => {
          if (!currentState3) {
            document.getElementById('unescoTemples').scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
          }
        }
      );

    }
  }
  render() {
    return (
      <div className="container lang" data-homecnt="true" ref={this.myRef} onScroll={this.onScroll}>
        <Navlang />
        <div className="curoselCnt">
          <div className="textCnt">
            <p>எழுத்தாளர், நடிகர், சமூக ஆர்வலர்</p>
            <span onClick={() => this.showAbout()} className="btn btnPrimary">என்னை பற்றி</span>
          </div>
          <div className="imgWrap">
            <div className="imgCnt"></div>
            <img src={require('../../assets/person.png')} />
          </div>
        </div>
        <div className="cardView">
          <div className="card">
            <p className="title">செய்திகள் & நிகழ்வுகள்</p>
            <marquee data-events-continer='true' behavior="scroll" direction="up" scrolldelay="280">
              {this.state.currMnthEvent.map(function (item, index) {
                let thisDate = new Date(item['date']);
                thisDate = thisDate.getDate() + '/' + (Number(thisDate.getMonth()) + 1) + '/' + thisDate.getFullYear();
                return <p key={index} className="marqueeText">{thisDate + ' - ' + item['textcnt']}</p>
              })}
            </marquee>
          </div>
          <div className="card clkCnt">
            <div className="title">
              <p>{this.state.currDate}</p>
              <p>{this.state.currTime}</p>
            </div>
            <Clock />
          </div>
        </div>
        <div className="about">
          <div className="pointsWrap">
            <h1>என்னை பற்றி
            <span className="selcted"></span>
            </h1>
            <div className="pointsBlk" id="aboutCnt">
              <div className="points">1</div>
              <div className="pointsCnt">
                <h2>நடிகன்</h2>
                <p>என் குறும்படங்கள்</p>
                <div className="iframeCnt">
                  <iframe src="https://www.youtube.com/embed/_A3T7iCmPNs" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/3OSKGt9scFg" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/PuvfrqKdxqU" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/mXsRprQ1vqQ" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/mDUQQgxM3uc" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/uAFILAHBv4s" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                  <iframe src="https://www.youtube.com/embed/P3Ba_H0h1sA" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
                </div>
              </div>
            </div>
            <div className="pointsBlk">
              <div className="points">2</div>
              <div className="pointsCnt">
                <h2>எழுத்தாளர்</h2>
                <p>எனது புத்தகம் / பதிப்புகள்</p>
                <BannerCarousel></BannerCarousel>
              </div>
            </div>
            <div className="pointsBlk">
              <div className="points pt3">3</div>
              <div className="pointsCnt">
                <h2>சிறந்த தொழில்முனைவோர்:<span className="btn btnPrimary downloadFile"><a href={'../resources/PDF.pdf'} target="_blank">DownloadFile</a></span></h2>
                <div className="firstPara">
                  <p>லோக. சந்திரபிரபு – கல்கி வார இதழில் ‘ஆன்மாவைத்தேடி’ என்கிற
                  கட்டுரைத் தொடரை எழுதிய இவர் ‘நீரோடுதான் நான் பேசினேன்’ என்கிற நூலை
                  கடந்த 2017ல் எழுதி வெளியிட்டார். நீரும் கதாசிரியரும் பேசிக் கொள்வதாய்
                  அமையும் இந்த நூலில் நீர் பற்றிய எண்ணற்ற தகவல்களை நீரே தருவது போல்
                  அமைக்கப்பட்டுள்ளது. ஒரு சிறந்த தொழில் முனைவோராகவும் சிறந்த
                  பத்திரிக்கையாளராகவும், சிறந்த எழுத்தாளராகவும், கலை உலகில் குறும்பட
                  தயாரிப்பாளராகவும், நடிகராகவும், இயக்குனராகவும் பல சமூக நல
                  அமைப்புகளில் முக்கிய பொறுப்புகளை வகித்து வரும் சமூக சேவகராகவும்
                  விளங்கும் பன்முகத் தன்மையுடைய இவரைப் பற்றி முழுமையாக இந்த
                  வலைதளத்தில் தெரிந்து கொள்வோம்.
                  </p>
                </div>
                <p className="otherPara">
                  <b>சிறுவயது வாழ்க்கை:</b><br />
                  இவர் 23.04.1970-ல் கும்பகோணத்தில் பிறந்த இவரின் தந்தை காலம் சென்ற S.லோகபாலன் அவர்களுக்கு விழுப்புரம் – திண்டிவனம் இடையில் உள்ள வீடூர் கிராமம் பூர்வீகமாகும். இவரின் 7வது வயதிலேயே தந்தை லோகபாலன் இறந்துவிட்டதால் தாயார் சுலோச்சனா அம்மாள் அவர்களின் சொந்த ஊரான கும்பகோணத்திலேயே வளரத் தொடங்கினார். இவருக்குப் பிறகு 1972-ல் பிறந்த சந்திரகலா என்கிற இவரின் தங்கையையும் (அவரும்1987ல் இறந்துவிட்டார்) இவரையும் படிக்க வைக்கவும், காப்பாற்றவும் முடியாததால் இவரின் தாயும், உறவினர்களும் இணைந்து கும்பகோணம் அருகில் உள்ள கொட்டையூர் வள்ளலார் மாணவர் இல்லம் என்கிற அனாதை ஆஸ்ரமத்தில் சேர்த்து விட்டனர். 1978லிருந்து 3ம் வகுப்பு துவங்கி 10ம் வகுப்பு வரை அங்கே கல்வி பயின்ற இவரின் கல்வி கண்ணை திறந்தவர் அந்த அனாதை ஆஸ்ரமத்தையும், வள்ளலார் கல்வி அறநிலையங்களையும் நிறுவிய தவத்திரு ராமதாஸ் அண்ணா அவர்கள்தான்! அவரே இவருக்கு குருவாகவும், ஞானத் தந்தையாகவும் விளங்கினார்.</p>
                <p className="otherPara">இவர் படிக்கும் காலத்தில் உயர்நிலைப்பள்ளியாக இருந்ததால் வள்ளலார் பள்ளியில் 10ம் வகுப்பு வரையே இவரால் அங்கு கல்வி கற்க முடிந்தது. தற்போது அப்பள்ளி 4500 மாணவர்களோடு மேல்நிலைப்பள்ளியாக தரம் உயர்ந்துள்ளது. பள்ளிப்படிப்போடு அனாதை இல்லத்திலிருந்து வெளியேறிய இவர் தனது கல்விப் பசியை போக்கிக் கொள்ள தனித் தேர்வராக +2 படித்து பிறகு அண்ணாமலை பல்கலைக்கழகத்தில் முதுகலை வரலாறு அஞ்சல் வழியில் பயின்றார்.</p>
                <p className="otherPara">
                  <b>இளவயது வாழ்க்கை:</b><br />
                SSLCக்கு பிறகு வள்ளலார் அனாதை இல்லத்திலிருந்து வெளியேறிய இவர் தனது தாயாரோடு வாழ்க்கையைத் துவக்கினார். கல்விப்பசிக்கு தனித்தேர்வராக பயின்றாலும் வயிற்றுப் பசியை போக்க வேண்டுமே? அதனால் ஏதாவது ஒரு வேலைக்கு சென்றே ஆக வேண்டும் என்கிற கட்டாயத்தில் சோடா கம்பெனி ஒன்றில் வேலைக்கு செல்ல ஆரம்பித்தார். 1987-ல் ‘சில்வர் ஸ்டார்’ என்கிற அந்த சோடாக்கம்பெனியில் வேலைக்கு சேர்ந்த இவர் தனது முதலாளியின் கடன் சிரமங்களை ஏற்றுக்கொண்டு 1992ல் அதே நிறுவனத்தை வாங்கி நடத்த ஆரம்பித்தார்.</p>
                <p className="otherPara">
                  கும்பகோணத்தில் மகாமகம் நடந்த 1992ல் தான் துவங்கியது இவரின் தொழில் வாழ்வு. 1993க்கு பிறகு நம்நாட்டில் ஏற்பட்ட தாராளமய பொருளாதார கொள்கையால் பன்னாட்டு நிறுவனங்கள் இந்தியாவின் உள்ளே வளரத் துவங்கின. அதே நேரத்தில் பிளாஸ்டிக் பயன்பாடும் அதிகரிக்கத் துவங்கியது. அதனால் செரிமானத்திற்காகவும், தாகத்திற்காகவும் மக்கள் குடித்து வந்த சோடாவை விட்டுவிட்டு அதற்கு பதில் 7UP போன்ற பன்னாட்டு குளிர்பானங்களுக்கு மாறத்துவங்கினர். மேலும் பாக்கெட்களில் குடிநீர், ரஸ்னா போன்ற குளிர்பானங்களும் சந்தையில் வரத் துவங்கியதால் அனைத்து உள்நாட்டு சோடா கம்பெனிகளுக்கும் சந்தை வாய்ப்புகள் மங்கத் துவங்கியது. இவருடைய சோடா நிறுவனமும் விற்பனையில் சரிவை சந்தித்தது.
                </p>
                <p className="otherPara">
                  பிறகு மக்களின் தேவைக்கேற்ப தன்னையும் தன் நிறுவனத்தையும் மாற்ற வேண்டிய கட்டாயத்தில் ‘ரஸ்னா’ பாக்கெட்டுகளில் குளிர்பானங்களை அடைத்து விற்கத் துவங்கினார். கடலூரில்உள்ள ‘ஆல்ப்ஸ்’ என்ற குடிநீர் கம்பெனியின் குடிநீருக்கு கும்பகோணம் நகரத்தின் விநியோகஸ்தராகி 1998ல் குடிநீர் வியாபாரத்திலும் கால் பதிக்கத் துவங்கினார். பிறகு 2000த்தில் ‘Pure Today’ என்கிற குடிநீர் நிறுவனத்தை சொந்தமாக துவக்கி நடத்த ஆரம்பித்தவுடன் ‘சில்வர் ஸ்டார்’ சோடா கம்பெனி தன் இறுதி மூச்சை நிறுத்தியது.
                </p>
                <p className="otherPara">
                  2000த்தில் Pure Today ஆரம்பிக்கப்பட்டவுடன் 2001ல் காஞ்சிபுரத்தைச் சேர்ந்த ராஜேந்திரன் – ராஜேஸ்வரியின் 6வது மகளான லதாவை திருமணம் செய்தார். இவரின் இல்வாழ்க்கையில் 2002ல் சசிப்ரியாவும் 2007ல் ஜினஸ்ரீலஷ்மியும் மகள்களாக பிறந்தனர். இவர் மனைவி லதா கும்பகோணத்தில் அரசு உதவி பெறும் பள்ளியில் ஆசிரியையாக பணியாற்றி வருகிறார். இவரின் மூத்தமகள் சசிப்ரியா பாண்டிச்சேரி மகாத்மா காந்தி மருத்துவ கல்லூரியில் மருத்துவம் பயின்று வருகிறார்.
                </p>
                <p className="otherPara">
                  2000த்தில் மிகச்சிறியதாக ஆரம்பிக்கப்பட்ட Pure Today என்கிற இவரின் மினரல் வாட்டர் நிறுவனத்திற்கு 2002ல் ஒரு சோதனை. ISI முத்திரை இருந்தால்தான் குடிநீர் ஆலைகள் இயங்க முடியும் என்கிற அரசின் புதிய சட்டத்தால் இவர் நிறுவனம் தடை செய்யப்பட்டது.
                </p>
                <p className="otherPara">
                  பிறகு 2004ல் ISI தரச்சான்றுடன் ‘வின்வே வாட்டர்’ என்கிற பெயருடன் இவரின் Pure Today புதிய அவதாரம் எடுத்து இன்று வரை சிறப்பாக இயங்கி வருகிறது. பல்வேறு சோதனைகளுக்கும், போராட்டங்களுக்கும் இடையில் கடும் தொழிற்போட்டியின் ஊடேயும் இவர் இதை சாதித்து வருகிறார்.
                </p>
                <p className="otherPara">
                  <b>இலக்கியப்பணி:</b><br />
                  1987ல் சோடா கம்பெனிக்கு வேலைக்கு சென்ற இவர் “பங்க் ஸ்டால்” என்று அழைக்கப்படும் ஒவ்வொரு பெட்டி கடைகளிலும், சோடாவை கொடுத்துவிட்டு பணம் வசூல் செய்யும் நேரங்களில் கடைகளில் மாட்டி தொங்கிக் கொண்டிருக்கும் ஆனந்த விகடன், குமுதம், கல்கி போன்ற வார, மாத பத்திரிக்கைகளை படிக்கத் துவங்கி அந்த பத்திரிக்கைகளுக்கு வாசகர் கடிதம், கேள்வி – பதில் பகுதிகளுக்கு கடிதங்களை அனுப்பத் துவங்கினார். முதன்முதலில் இவருடைய சிரிப்புத் துணுக்கு வலம்புரி ஜான் அவர்களின் “தாய்” வார பத்திரிக்கையில் 1987ல் வெளிவந்தது. துணுக்குகள் எழுதிக் கொண்டிருந்த இவர் நாளடைவில் சிறுகதை எழுத்தாளராகவும் உயர்ந்தார்.
                </p>
                <p className="otherPara">
                  இவர் எழுதி பத்திரிக்கையில் வெளிவந்த துணுக்குகள், சிரிப்புகள் மற்றும் சமூகநலனோடு அரசுக்கு வைத்த கோரிக்கைகள் ஆகியவற்றைத் தொகுத்து ‘பேனாச்சோறு’ என்கிற புத்தகத்தையும் தொகுத்து வெளியிட முடிவு செய்துள்ளார். இவரின் முதல் புத்தகம் ‘நீரோடுதான் நான் பேசினேன்’. இந்த நூலில் நீரும் கதையாசிரியரும் பேசிக் கொள்வதாக அமைத்துள்ளார். நீர் பற்றிய எண்ணற்றத் தகவல்களை நீரே வழங்குவது போல் எழுதப்பட்டுள்ளது இதன் சிறப்பு.
                </p>
                <p className="otherPara">
                  இவரின் 2வது நூல் ‘அன்புறவாடல்’. இவர் எழுதி தினத்தந்தி ஞாயிறு மலர் முதற்கொண்டு சிற்றிதழ்களில் வெளிவந்த 28 சிறுகதைகளின் தொகுப்பு இது. இந்த கதைகளிலிருந்தே இவர் 7 குறும்படங்களையும் தயாரித்துள்ளார். இவரின் இந்த நூல் 29.11.2019ல் துபாய் தமிழ்சங்கத்தின் மூலம், நந்தவனம் பதிப்பகத்தாரால் துபாயில் வெளியிடப்பட்டது.
                </p>
                <p className="otherPara">
                  600 ஹைக்கூ கவிதைகள் அடங்கிய இவரின் 3வது நூல் ‘அம்மா பின்னிய கூடை’ முழுவதும் வண்ணப்பக்கங்களோடு வெளிவந்துள்ளது. இந்நூல் பலரின் பாராட்டைப் பெற்றது. இவரின் 4வது நூல்தான் ‘பேனாச்சோறு’ அதைப்பற்றி முன்பே பார்த்தோம்.
                </p>
                <p className="otherPara">
                  சின்ன சின்ன சிரிப்புத் துணுக்குகளை எழுத ஆரம்பித்து, பிறகு பல நூல்களை எழுதிய  இவர் தற்போது 2020ல் ‘ஆன்மாவைத் தேடி’ என்கிற கட்டுரைத் தொடரை கல்கியில் எழுதியுள்ளார். 16 வாரங்கள் வெளிவந்த இந்த தொடர் சற்று வித்தியாசமானது. தமிழகத்தில் தற்சார்போடு இயங்கி வரும் வித்தியாசமான கிராமங்களைப் பற்றியது இவரின் இந்த படைப்பு. ஆச்சரியமூட்டும் அதிசய கிராமங்களாக திகழும் 50 கிராமங்களைத் தேர்ந்தெடுத்து அந்த கிராமங்களுக்கே நேரடியாகச் சென்று அந்த கிராமங்களின் சிறப்பியல்புகளை எழுதியுள்ளார். அவற்றில் 16 கிராமங்கள் பற்றிய செய்திதான் கல்கியில் தொடராக வெளிவந்துள்ளது. முத்திரை பதிக்கும் முத்தான 50 கிராமங்களைப் பற்றிய இவரின் இந்த தொகுப்பு ‘ஆன்மானவைத் தேடி’ என்கிற 5வது நூலாக விரைவில்வெளிவர உள்ளது.
                </p>
                <p className="otherPara">
                  இப்படியாக இவரின் இலக்கியப்பணி தொடர்கிறது.
                </p>
                <p className="otherPara">
                  <b>கலை உலக வாழ்க்கை:</b><br />
                  இவர் இயக்கி, எழுதி தயாரித்த குறும்படங்கள் இதுவரை 7. கடந்த  2018ம் ஆண்டு மதுவுக்கு எதிரான “அம்மாவின் 50 ரூபாய்” என்கிற குறும்படத்தை எழுதி தயாரித்தார். அதற்கு பிறகு “நீர்நியதி”, என்கிற குறும்படம் குடிநீர் தொழிலாளியின் கதை. “யாதனின் யாதனின்” என்கிற குறும்படம் பிளாஸ்டிக் விழிப்புணர்வுக்கானது. ஜுலை -8 என்கிற குறும்படம் உயிர்காக்கும் ஆம்புலன்ஸ்க்காக உலக ஆம்புலன்ஸ் நாள் வேண்டும் என்பதை உணர்த்துகிறது. விஸ்வாசம் என்கிற குறும்படம் Management Technique பற்றியது. ‘இனியொரு’ குறும்படம் Waste Plastic மறுசுழற்சி பற்றியது. அப்துல்லாவின் ஆசை மத நல்லிணக்கத்தை உணர்த்தும் உணர்வுப் பூர்வமான குறும்படம். இப்படியாக சமூகபார்வையோடு இவரின் குறும்படங்கள் அமைந்துள்ளன.
                </p>
                <p className="otherPara">
                  இவரின் எழுத்துக்களில் வெளியான இந்த குறும்படங்களில் ஜுலை -8, யாதனின் யாதனின், விஸ்வாசம், அப்துல்லாவின் ஆசை ஆகியவற்றில் இவரே முக்கிய கதா பாத்திரங்களில் நடித்துள்ளார். இப்படியாக சமூக விழிப்புணர்வை வலியுறுத்துயவாறு இவரின் கலை உலக வாழ்வும் தொடர்கிறது. இவரின் குறும்படங்களின் லிங்குகள் (link), அனைத்தும் இதே websiteல் இணைக்கப்பட்டுள்ளது. அனைவரும் கண்டுகளியுங்கள்.
                </p>
                <p className="otherPara">
                  <b>சமூக சேவையில்:</b><br />
                2000ல் மினரல் வாட்டர் தொழிற்சாலையைத் துவக்கிய பிறகு 2001ல் தன்னை கும்பகோணம் ரோட்டரி சங்கத்தில் இணைத்துக்கொண்டார். ரோட்டரி உறுப்பினராகிய பின் 2008-09ல் சங்க செயலாளராகவும், 2012-13ல் சங்கத்தின் தலைவராகவும் பணியாற்றினார். 2013ல் இவர் தலைவராக இருந்தபொழுது அடிக்கல் நாட்டி தொடங்கிய ரோட்டரி இரத்த வங்கி இன்று வரை மிகச்சிறப்பாக செயல்பட்டு வருகின்றது. அதற்கு முக்கிய காரணம் இவருடைய ஆத்மார்தமான நண்பர் Rtn.முகம்மது ஜீயாவுதீன் என்பவர்தான்.
                </p>
                <p className="otherPara">
                  பிறகு சர்வதேச ரோட்டரியில் 2017-2018ம் ஆண்டிற்கான உதவி ஆளுநராகவும் சிறப்பாக பணியாற்றினார். தொடர்ந்து ரோட்டரியில் சேவையாற்றி வரும் இவர் 2012-2014ம் ஆண்டிற்கான கும்பகோணம் சேம்பர் ஆப் காமர்ஸ்ன் தலைவராகவும் பணியாற்றி கும்பகோணம் பகுதி மக்களுக்காக நிறைய கோரிக்கைகளை அரசிடம் கொண்டுசென்று செயல்படுத்தினார். கும்பகோணம் ஸ்ரீகிருஷ்ண ஜெயந்தி விழாக்குழுவின் தலைவராக கடந்த 2014ம்  ஆண்டு முதல் இன்று வரை பணியாற்றி வரும் இவர் இதன் மூலம் கும்பகோணம் பகுதியில் உள்ள 55க்கும் மேற்பட்ட பள்ளிகளில் உள்ள சுமார் 3500க்கும் அதிகமான மாணவ-மாணவியருக்கு போட்டிகளை நடத்தி வெற்றி பெற்றவர்களுக்கு சான்றிதழ்களும், பரிசுகளும் வழங்கி வருகிறார். இக்குழுவானது பள்ளி மாணவ, மாணவியருக்கு இளம் பருவத்திலேயே ஆன்மிக எண்ணங்களையும், தேசப்பற்றையும் விதைப்பதற்காக 35 ஆண்டுகளுக்கு முன்உருவாக்கப்பட்டது. இதன் மூலம் இவர் தன்னை ஒரு சிறந்த தேசப் பற்றாளராக உருவாக்கிக் கொண்டுள்ளார்.
                </p>
                <p className="otherPara">
                  மேலும் குடிநீர் தொழில்சார்ந்த அமைப்பான ‘கிரேட்டர் தமிழ்நாடு குடிநீர் உற்பத்தியாளர்கள்’ சங்கத்தின் மாநில துணை தலைவராகவும் செயலாற்றி வருகிறார். கும்பகோணம் ரெட் கிராஸ்சின் ஆயுள் கால உறுப்பினராகவும், கும்பகோணம் சரஸ்வதி கான சபாவின் ஆயுள்கால உறுப்பினராகவும் பணியாற்றி வரும் இவரின் சமூக சேவைகளைப் பார்த்து 2020ம் ஆண்டு தென்னக ரயில்வே ‘station Consultative committee’ உறுப்பினராக்கி கௌரவப்படுத்தியுள்ளது.
                </p>
                <p className="otherPara">
                  வள்ளலார் அனாதை இல்லத்தில் படித்து ரோட்டரி செல்வந்தர்களின் கல்வி உதவித் தொகையைப் பெற்று ஒரு பயனாளியாக இருந்து படித்து உயர்ந்து பிறகு அதே ரோட்டரியில் தன்னை இணைத்துக்கொண்டு பெருங்கொடையாளியாகவும் (Major Donor) இன்று உயர்ந்துள்ளார். <b>இவரின் சமூகப் பணியும், கலை இலக்கிய பணியும் மேலும் தொடரட்டும்.</b>
                </p>
              </div>
              <div className="imgAbout">
                <div className="roundAnimation">
                  <img src={require('../../assets/person2.png')} />
                </div>
              </div>
            </div>
            <div className="logoCnt">
              <img src={require('../../assets/saiKiruba.png')} />
              <a href={'http://www.winway.in/'} target="_blank">
                <img src={require('../../assets/milestone_02.png')} />
              </a>
              <img src={require('../../assets/saiKiruba.png')} />
            </div>
          </div>

        </div>
        <div className="dropCnt">
          <a href={'../resources/template-around-kumbakonam.jpg'} target="_blank">
            <div className="dropDown">
              <span>கும்பகோணத்தைச் சுற்றியுள்ள கோயில்கள்<FontAwesomeIcon className="floatRight dropdownIcon" icon={faAngleDown} /></span>
            </div>
          </a>
          <div className="dropDown" id='otherPilgrimages' onClick={() => this.toggleClass('otherPilgrimages')}>
            <span>நவகிரக பாதையில் மற்ற யாத்திரை<FontAwesomeIcon className="floatRight dropdownIcon" icon={faAngleDown} /></span>
            <img className={this.state.otherPilgrimages ? 'show' : 'hide'} src={require('../../assets/c1.png')} />
          </div>
          <div className="dropDown" id='nearestTourism' onClick={() => this.toggleClass('nearestTourism')}>
            <span>நவகிரக பாதையில் அருகிலுள்ள சுற்றுலா<FontAwesomeIcon className="floatRight dropdownIcon" icon={faAngleDown} /></span>
            <img className={this.state.nearestTourism ? 'show' : 'hide'} src={require('../../assets/c2.png')} />
          </div>
          <div className="dropDown" id='unescoTemples' onClick={() => this.toggleClass('unescoTemples')}>
            <span>UNESCO கோயில்கள்<FontAwesomeIcon className="floatRight dropdownIcon" icon={faAngleDown} /></span>
            <img className={this.state.unescoTemples ? 'show' : 'hide'} src={require('../../assets/banner3.png')} />
          </div>
        </div>
        <img className={this.state.showDottedAnim ? "dottedAnim" : "hidden"} src={require('../../assets/dottedpattern.png')} />
        <div className={this.state.showDottedAnim ? "moveToTop" : "nameAnim"}><img src={require('../../assets/rotarylogo.png')} /><p>லோக சந்திரபிரபு</p></div>
        <Footerlang></Footerlang>
      </div>
    );
  }
}

export default Homelang;
